import { useSelector } from "react-redux";
import { openInNewTab } from "../../../../../../shared/utils/utils";
import PrimaryBtn from "../../../../../../shared/components/ui/buttons/PrimaryBtn";
import downloadIcon from "../../../../../../assests/icons/document-download.png";
import classes from "./CreateCourseResponse.module.css"

const CreateCourseResponse = ({ status, body, successText, errorText, showErrorPdf }) => {

    const { texts } = useSelector(state => state.translate);
    const { general } = useSelector(state => state.uiData)

    return (
        <div className={classes.CreateCourseResponse}>
            {status === 200 ?
                <div className={classes.SuccessText}>
                    <p >{successText}</p>
                    <PrimaryBtn dropClass={classes.BtnLink} onClick={() => { openInNewTab(body?.course?.link) }}>{texts.MoveToStudyGroup} </PrimaryBtn>
                </div>
                : status === 429 ?
                    <div className={classes.SuccessText}>
                        <p >{texts.tooManyRequests}</p>
                    </div>
                    :
                    <div className={classes.SuccessText}>
                        <p >{errorText}</p>
                        {showErrorPdf && <PrimaryBtn dropClass={classes.BtnDownload} onClick={() => { openInNewTab(general?.downloadPageInCreateStudyGroup) }}>
                            <img src={downloadIcon} />
                            {texts.solutionInCreateStudyGroup}
                        </PrimaryBtn>}
                    </div>
            }
        </div >
    )
}

export default CreateCourseResponse;